const movements = [
    { id: 0, name: "Reembolso" },
    { id: 1, name: "Anticipo" },
    { id: 2, name: "Tarjeta" },
    // { id: 3, name: "CajaChica" }
];

export default movements;